import Button from '~/components/common/button'
/* eslint-disable react/jsx-handler-names */
import React from 'react'
import appConfig from '../app-config'
import { isMobile } from '../core/utils'
import styled from 'styled-components'
import { translate } from '~/core/translate'

const StyledButton = styled(Button)`
  margin-top: 16px;
`

const GotoAppButton = ({ onBeforeRedirect, buttonDisabled }) => {
  if (!isMobile() || appConfig.current.isAuth0Redirect) {
    return (
      <StyledButton
        disabled={buttonDisabled}
        onClick={() => {
          onBeforeRedirect && onBeforeRedirect()
          appConfig.current.goToApp()
        }}
        secondary
      >
        {translate('go_to_app')}
      </StyledButton>
    )
  }

  return null
}

export default GotoAppButton
